import { string } from "prop-types";

type Config = {
  apiURL: string,
  hotelId: string,
  lang: string[],
  email: string,

  // apiUrl: string,
  // karnetLogo: string,
  // numberPhone: string,
   platnoscKod2: string,
   platnoscKod3: string,

  karnetApiUrl: string,
  karnetLogo: string,


  karnetPrzerwa: string,                    
  karnetPrzydzial: string,

  karnetZasady1: string,
  karnetZasady1Opis: string,
  karnetZasady1Link: string,
  karnetZasady1Zaznacz: string,
  karnetZasady2: string,
  karnetZasady2Opis: string,
  karnetZasady2Link: string,
  karnetZasady2Zaznacz: string,
  karnetZasady3: string,
  karnetZasady3Opis: string,
  karnetZasady3Link: string,
  karnetZasady3Zaznacz: string,

  karnetIkonaPrzelewy24: string,
  karnetIkonaMBank: string,

  karnetPayWebPrefiks: string,
  karnetPayWebKontoId: string,

  // przerwa: string,
  karnetPlatnoscLink: string,
  karnetZjedzLink: string,
  karnetZanocujLink: string,

  karnetPlikIni: string,
};

let CONFIG: Config = {
  apiURL: "https://vsc24.net:443/vscSmartSki/",  
  hotelId: 'lesko-SKI',
  lang: ["pl", "en", "sk", "de"],
  email : "virtual@onet.pl",

  // apiUrl: 'https://vsc24.net:443/vscSmartSki/',
  // karnetLogo: '234',
  // numberPhone: '',
   platnoscKod2: '1111',
   platnoscKod3: '2222',

  karnetApiUrl: "http://192.168.130.19:8094",  
  karnetLogo: '00001',


  karnetPrzerwa: "0",                       
  karnetPrzydzial: "XARC00",  

  karnetZasady1: "0",
  karnetZasady1Opis: "",
  karnetZasady1Link: "",
  karnetZasady1Zaznacz: "0",
  karnetZasady2: "0",
  karnetZasady2Opis: "",
  karnetZasady2Link: "",
  karnetZasady2Zaznacz: "0",
  karnetZasady3: "0",
  karnetZasady3Opis: "",
  karnetZasady3Link: "",
  karnetZasady3Zaznacz: "0",

  karnetIkonaPrzelewy24: "",
  karnetIkonaMBank: "",

  karnetPayWebPrefiks: "ski",
  karnetPayWebKontoId: "2",

  // przerwa: "0",

  karnetPlatnoscLink: "1",
  karnetZjedzLink: "1",
  karnetZanocujLink: "1",

  karnetPlikIni: "WEB.INI",

};

// npm install typings --global
// https://stackoverflow.com/questions/50488121/typescript-add-functions-to-window-with-d-ts-file

interface WindowInterface extends Window {
  config: Config;
}

let window2config = () => { // uruchamiane w App : render()
  var config : Config = (window as unknown as WindowInterface).config || {
    // gdy nie ma public/config.js, ustawiam na parametry z kompilacji - def. wyżej
    apiURL : CONFIG.apiURL,
    hotelId : CONFIG.hotelId,
    lang : CONFIG.lang,
    email : CONFIG.email,

    // apiUrl : CONFIG.apiUrl,
    // karnetLogo : CONFIG.karnetLogo,
    // numberPhone: CONFIG.numberPhone,
     platnoscKod2: CONFIG.platnoscKod2,
     platnoscKod3: CONFIG.platnoscKod3,

    karnetApiUrl: CONFIG.karnetApiUrl,
    karnetLogo: CONFIG.karnetLogo,

    karnetPrzerwa: CONFIG.karnetPrzerwa,
    karnetPrzydzial: CONFIG.karnetPrzydzial,

    karnetZasady1: CONFIG.karnetZasady1,
    karnetZasady1Opis: CONFIG.karnetZasady1Opis,
    karnetZasady1Link: CONFIG.karnetZasady1Link,
    karnetZasady1Zaznacz: CONFIG.karnetZasady1Zaznacz,
    karnetZasady2: CONFIG.karnetZasady2,
    karnetZasady2Opis: CONFIG.karnetZasady2Opis,
    karnetZasady2Link: CONFIG.karnetZasady2Link,
    karnetZasady2Zaznacz: CONFIG.karnetZasady2Zaznacz,
    karnetZasady3: CONFIG.karnetZasady3,
    karnetZasady3Opis: CONFIG.karnetZasady3Opis,
    karnetZasady3Link: CONFIG.karnetZasady3Link,
    karnetZasady3Zaznacz: CONFIG.karnetZasady3Zaznacz,

    karnetIkonaPrzelewy24: CONFIG.karnetIkonaPrzelewy24,
    karnetIkonaMBank: CONFIG.karnetIkonaMBank,

    karnetPayWebPrefiks: CONFIG.karnetPayWebPrefiks,
    karnetPayWebKontoId: CONFIG.karnetPayWebKontoId,

    // przerwa: CONFIG.przerwa,
    karnetPlatnoscLink: CONFIG.karnetPlatnoscLink,
    karnetZjedzLink: CONFIG.karnetZjedzLink,
    karnetZanocujLink: CONFIG.karnetZanocujLink,

    karnetPlikIni: CONFIG.karnetPlikIni,
  }
  CONFIG.apiURL =  config.apiURL;
  CONFIG.hotelId =  config.hotelId;
  CONFIG.lang =  config.lang;
  CONFIG.email =  config.email;
  
  // CONFIG.apiUrl = config.apiUrl;
  // CONFIG.karnetLogo = config.karnetLogo;
  // CONFIG.numberPhone = config.numberPhone;
   CONFIG.platnoscKod2 = config.platnoscKod2;
   CONFIG.platnoscKod3 = config.platnoscKod3;

  CONFIG.karnetApiUrl = config.karnetApiUrl;
  CONFIG.karnetLogo = config.karnetLogo;

  CONFIG.karnetPrzerwa = config.karnetPrzerwa;
  CONFIG.karnetPrzydzial = config.karnetPrzydzial;

  CONFIG.karnetZasady1 = config.karnetZasady1;
  CONFIG.karnetZasady1Opis = config.karnetZasady1Opis;
  CONFIG.karnetZasady1Link = config.karnetZasady1Link;
  CONFIG.karnetZasady1Zaznacz = config.karnetZasady1Zaznacz;
  CONFIG.karnetZasady2 = config.karnetZasady2;
  CONFIG.karnetZasady2Opis = config.karnetZasady2Opis;
  CONFIG.karnetZasady2Link = config.karnetZasady2Link;
  CONFIG.karnetZasady2Zaznacz = config.karnetZasady2Zaznacz;
  CONFIG.karnetZasady3 = config.karnetZasady3;
  CONFIG.karnetZasady3Opis = config.karnetZasady3Opis;
  CONFIG.karnetZasady3Link = config.karnetZasady3Link;
  CONFIG.karnetZasady3Zaznacz = config.karnetZasady3Zaznacz;

  CONFIG.karnetIkonaPrzelewy24 = config.karnetIkonaPrzelewy24;
  CONFIG.karnetIkonaMBank = config.karnetIkonaMBank;

  CONFIG.karnetPayWebPrefiks = config.karnetPayWebPrefiks;
  CONFIG.karnetPayWebKontoId = config.karnetPayWebKontoId;

  // CONFIG.przerwa = config.przerwa;
  CONFIG.karnetPlatnoscLink = config.karnetPlatnoscLink;
  CONFIG.karnetZjedzLink = config.karnetZjedzLink;
  CONFIG.karnetZanocujLink = config.karnetZanocujLink;

  CONFIG.karnetPlikIni = config.karnetPlikIni;
}

export {window2config}
export default CONFIG;
